import Content from './content/indexS';

export default Content;
